import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';

interface NavProps {
  onRequestDemo: () => void;
}

export function Nav({ onRequestDemo }: NavProps): JSX.Element {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const onLanding = pathname === '/' || pathname === '';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // In-page anchors only work on the landing page. From /pricing they need
  // to navigate to `/#section` so the browser scrolls after route change.
  const anchorPrefix = onLanding ? '' : '/';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-200 ${
        scrolled
          ? 'bg-navy-900/85 backdrop-blur-md border-b border-white/10'
          : 'bg-transparent'
      }`}
    >
      <div className="container-x flex h-16 items-center justify-between">
        <Link to="/" aria-label="Opinix home">
          <Logo />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-steel-300">
          <a
            href={`${anchorPrefix}#platform`}
            className="hover:text-white transition-colors"
          >
            Platform
          </a>
          <a
            href={`${anchorPrefix}#verticals`}
            className="hover:text-white transition-colors"
          >
            Verticals
          </a>
          <a
            href={`${anchorPrefix}#capabilities`}
            className="hover:text-white transition-colors"
          >
            Capabilities
          </a>
          <a
            href={`${anchorPrefix}#deployment`}
            className="hover:text-white transition-colors"
          >
            Deployment
          </a>
          <Link
            to="/pricing"
            className={`transition-colors ${
              pathname.startsWith('/pricing')
                ? 'text-white'
                : 'hover:text-white'
            }`}
          >
            Pricing
          </Link>
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="/admin/"
            className="hidden sm:inline-flex text-sm font-medium text-steel-300 hover:text-white transition-colors"
          >
            Sign in
          </a>
          <button
            type="button"
            onClick={onRequestDemo}
            className="btn btn-primary text-sm py-2 px-4"
          >
            Request a demo
          </button>
        </div>
      </div>
    </header>
  );
}
